/**
 * 2019-04-17
 * handan
 * 背调首页
 */

import React, { Component } from 'react'
import { connect } from "react-redux";
import { Checkbox, message } from "antd";
import "./style.scss";

import { addBatch } from "../../models";

class Home extends Component {
	constructor(props) {
		super(props)
		this.state = {
			checked: false,
			prompt: 'none',
		}
		this.onChangeChecked = this.onChangeChecked.bind(this);
		this.submit = this.submit.bind(this);
		this.onChangeInput = this.onChangeInput.bind(this);
	}
	render() {
		const { prompt } = this.state;
		return (
			<div className="Home-wrap">
				<div className="top">
					<img src="//pic1.58cdn.com.cn/nowater/cxnomark/n_v2e855a9a262304b3c8b9384a1a94483b5.png" alt="" />
				</div>
				<div className="content">
					<div className="form">
						<ul>
							<li>
								<i className="img_left"></i>
								<p>
									<span>服务客户</span>
									<em>1000+</em>
								</p>
							</li>
							<li>
								<i className="img_right"></i>
								<p>
									<span>累计查询</span>
									<em>10000+</em>
								</p>
							</li>
						</ul>
						<input type="text" placeholder="请输入被核实者姓名" className="input1" ref={input => this.nameInput = input} onChange={this.onChangeInput} />
						<span style={{
							color: 'red',
							marginLeft: '5px'
						}}>*</span>
						<input type="text" placeholder="请输入被核实者手机号" className="input1" ref={input => this.phoneInput = input} onChange={this.onChangeInput} />
						<span style={{
							color: 'red',
							marginLeft: '5px'
						}}>*</span>
						<input type="text" placeholder="请输入被核实者身份证号(选填)" ref={input => this.numberInput = input} onChange={this.onChangeInput} />

						<div className="prompt">提示：请确认信息准确性，提交之后无法修改！</div>
						<button className="btn" onClick={this.submit}>立即查看</button>
						<div className="statement">
							<Checkbox onChange={this.onChangeChecked}>
								我已经阅读并接受<a href="//check.58.com/uncheck/statement/statement_pc/#/home" target="_blank">服务声明</a>
							</Checkbox>
						</div>
					</div>
				</div>
			</div>
		)
	}

	onChangeChecked(e) {
		this.setState({
			checked: e.target.checked,
		})
	}
	onChangeInput() {
		let name = this.nameInput.value;
		let number = this.numberInput.value;
		let phone = this.phoneInput.value;
		if (name !== "" || number !== "" || phone !== "") {
			this.setState({ prompt: "" });
		} else {
			this.setState({ prompt: "none" });
		}
	}
	async submit() {
		const { setBatchId } = this.props;
		let name = this.nameInput.value;
		let number = this.numberInput.value;
		let phone = this.phoneInput.value;
		let obj = this.nameReg(name);
		if (!obj.flag) {
			this.showToast(obj.msg);
			return;
		}
		// let numObj = this.numberReg(number);
		// if(!numObj.flag){
		// 	this.showToast(numObj.msg);
		// 	return ;
		// }
		let phoneObj = this.validateMobile(phone);
		if (!phoneObj.flag) {
			this.showToast(phoneObj.msg);
			return;
		}
		if (!this.state.checked) {
			this.showToast("请勾选服务声明");
			return;
		}
		addBatch({ realName: name, idNo: number, phoneNo: phone, consent: this.state.checked, clientId: 'pc' }).then((res) => {
			setBatchId(res.id);
			this.props.history.push(`/verifyResult/${res.id}`)
		}).catch(() => { })
	}
	// 校验姓名
	nameReg(name) {
		if (name === "" || name === undefined) {
			return {
				flag: false,
				msg: "姓名不能为空"
			};
		} else {
			var reg = /^[\u4E00-\u9FA5\uf900-\ufa2dA-Za-z]{1}[\u4E00-\u9FA5\uf900-\ufa2dA-Za-z·]{0,18}[\u4E00-\u9FA5\uf900-\ufa2dA-Za-z]{1}$/;
			let flag = reg.test(name);
			return {
				flag,
				msg: "姓名格式错误"
			}
		}
		// return {
		// 	flag: true,
		// }
	}
	// 校验身份证
	numberReg(number) {
		if (number === "" || number === undefined) {
			return {
				flag: false,
				msg: "身份证号不能为空"
			}
		} else {
			var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
			let flag = reg.test(number);
			return {
				flag,
				msg: "身份证号格式错误"
			}
		}
	}
	/* 验证手机号码格式*/
	validateMobile(mobile) {
		if (mobile === "" || mobile === undefined) {
			return {
				flag: false,
				msg: "手机号不能为空"
			}
		} else {
			var reg = /^1\d{10}$/;
			let flag = reg.test(mobile);
			return {
				flag,
				msg: "手机号格式错误"
			}
		}
	}
	showToast(value) {
		message.warning(value, 1)
	}
}

const mapState = (store) => {
	return {
	}
}
const mapDispatch = (dispatch) => {
	return {
		setBatchId(data) {
			dispatch({
				type: "setBatchId",
				data,
			})
		},
	}
}
export default connect(mapState, mapDispatch)(Home);
